import { axiosClient } from './base'

export const createSubscription = async (data) => {
  return axiosClient.post('/admin/api/subscription', data)
}
